import { Component, Input, OnInit } from '@angular/core';
import { EventEmitterService } from '../../services/event-emitter.service';

@Component({
  selector: 'app-offer-status',
  templateUrl: './offer-status.component.html',
})
export class OfferStatusComponent implements OnInit {
  @Input() statusId: number;
  @Input() statusName: string;
  @Input() draftText: string;
  @Input() blocked: boolean;
  @Input() blockedText: string;
  className: string;

  constructor(private eventEmitterService: EventEmitterService) {}

  ngOnInit() {
    this.setClass();
    if (this.eventEmitterService.subsVar == undefined) {
      this.eventEmitterService.subsVar = this.eventEmitterService.invokeChangeOfferStatus.subscribe(
        (statusId: number) => {
          this.statusId = statusId * 1;
          this.setClass();
        }
      );
    }
  }

  setClass() {
    if (this.blocked) {
      this.className = 'bg_gray';
      this.statusName = this.blockedText;
    } else {
      switch (this.statusId || 0) {
        case 1:
        case 124:
        case 125:
        case 140:
        case 143:
        default:
          this.className = 'bg_blue';
          break;

        case 132:
        case 137:
        case 142:
          this.className = 'bg_green';
          break;

        case 133:
        case 134:
        case 135:
        case 136:
          this.className = 'bg_yellow';
          break;

        case 119:
        case 128:
        case 129:
        case 130:
        case 131:
          this.className = 'bg_red';
          break;

        case -1:
          this.className = 'bg_gray';
          break;

        case 0:
          this.className = 'bg_purple';
          this.statusName = this.draftText;
          break;
      }
    }
  }
}
